import React from 'react';
import { ProductModel } from '@models/product';

export const ClassRecommendation: React.FC<{ data: ProductModel }> = (props) => {
  const data = props.data;
  const recommendItemList: string[] = (data?.details?.recommendText || '')
    .split('\n')
    .map((line) => {
      return line.trim();
    })
    .filter((line: string) => line.length > 0);

  return (
    <div style={{ marginTop: '48px', paddingLeft: '16px', paddingRight: '16px' }}>
      <div
        style={{
          marginBottom: '10px',
          color: '#FF3D8F',
          fontSize: '18px',
          fontFamily: 'Glory',
          fontWeight: '800',
          lineHeight: '18px',
        }}>
        RECOMMEND
      </div>
      <div
        style={{
          color: '#242424',
          fontSize: '24px',
          fontWeight: '700',
          lineHeight: '26px',
        }}>
        어떤 아이에게 추천하나요
      </div>
      <div style={{ paddingTop: '16px', paddingBottom: '7px' }}>
        {recommendItemList.map((line, index) => {
          if (line[0] === '-') {
            line = line.replace(' - ', '').replace('- ', '').replace('-', '').replace(/^ /, '');
          }

          return (
            <div
              key={`recommend-${index}`}
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: '12px',
              }}>
              <div
                style={{
                  display: 'flex',
                  alignSelf: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: '#242424',
                  flexShrink: 0,
                }}>
                <div
                  style={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#ffffff',
                  }}>
                  {index + 1}
                </div>
              </div>
              <div
                style={{
                  marginLeft: '12px',
                  border: '1px solid #e8eaed',
                  borderRadius: '8px',
                  width: '100%',
                  padding: '16px',
                }}>
                <div
                  style={{
                    fontSize: '14px',
                    lineHeight: '21px',
                    color: '#424242',
                  }}>
                  {line}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
